import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminEscrow() {
  const [tab, setTab] = useState('disputes');
  const [disputes, setDisputes] = useState([]);
  const [fund, setFund] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [decision, setDecision] = useState('');
  const [notes, setNotes] = useState('');
  const [resolving, setResolving] = useState(false);
  const [imgModal, setImgModal] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [dRes, fRes] = await Promise.all([
        api.get('/api/v1/escrow/admin/disputes'),
        api.get('/api/v1/escrow/admin/reserve-fund'),
      ]);
      setDisputes(Array.isArray(dRes.data) ? dRes.data : []);
      setFund(fRes.data);
    } catch { } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleResolve = async () => {
    if (!decision || !notes.trim()) { alert('Selecciona decisión y escribe notas'); return; }
    setResolving(true);
    try {
      await api.post(`/api/v1/escrow/admin/${selected.transaction_ref}/resolve`, {
        decision,
        notes,
      });
      setDisputes(d => d.filter(x => x.transaction_ref !== selected.transaction_ref));
      setSelected(null);
      setDecision('');
      setNotes('');
      await load();
    } catch (e) {
      alert(e.response?.data?.detail || 'Error al resolver');
    } finally { setResolving(false); }
  };

  return (
    <div>
      {/* Image lightbox */}
      {imgModal && (
        <>
          <div onClick={() => setImgModal(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.85)', zIndex: 2000 }} />
          <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 2001 }}>
            <img src={imgModal} alt="Evidencia" style={{ maxWidth: '85vw', maxHeight: '85vh', borderRadius: 12 }} />
            <button onClick={() => setImgModal(null)} style={{ position: 'absolute', top: -16, right: -16, width: 36, height: 36, borderRadius: '50%', background: '#fff', border: 'none', cursor: 'pointer', fontSize: 18, fontWeight: 700 }}>✕</button>
          </div>
        </>
      )}

      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 26, margin: '0 0 4px' }}>Escrow</h1>
        <p style={{ fontSize: 13, color: '#7a7060', margin: 0 }}>
          {disputes.length} disputas pendientes
        </p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, background: '#f0ebe2', borderRadius: 10, padding: 4, marginBottom: 20, width: 'fit-content' }}>
        {[['disputes', '⚠️ Disputas'], ['fund', '🏦 Fondo de reserva']].map(([t, l]) => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 18px', borderRadius: 7, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, background: tab === t ? '#fff' : 'transparent', color: tab === t ? '#0f0d0b' : '#7a7060' }}>
            {l}
          </button>
        ))}
      </div>

      {/* Disputes tab */}
      {tab === 'disputes' && (
        <div style={{ display: selected ? 'grid' : 'block', gridTemplateColumns: '1fr 420px', gap: 18 }}>
          <div>
            {loading ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#7a7060' }}>Cargando...</div>
            ) : disputes.length === 0 ? (
              <div style={{ background: '#fff', borderRadius: 14, padding: 48, textAlign: 'center', border: '1px solid #e2dbd0' }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 18 }}>Sin disputas pendientes</div>
              </div>
            ) : disputes.map((d, i) => (
              <div key={i}
                onClick={() => setSelected(selected?.transaction_ref === d.transaction_ref ? null : d)}
                style={{ background: '#fff', border: `1px solid ${selected?.transaction_ref === d.transaction_ref ? '#c94a1e' : '#e2dbd0'}`, borderRadius: 12, padding: '16px 18px', marginBottom: 8, cursor: 'pointer' }}
                onMouseOver={e => { if (selected?.transaction_ref !== d.transaction_ref) e.currentTarget.style.background = '#f9f6f1'; }}
                onMouseOut={e => { if (selected?.transaction_ref !== d.transaction_ref) e.currentTarget.style.background = '#fff'; }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ fontFamily: 'monospace', fontSize: 11, color: '#c94a1e', marginBottom: 4 }}>{d.transaction_ref}</div>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2 }}>{d.recipient_name}</div>
                    <div style={{ fontSize: 12, color: '#7a7060' }}>{d.dispute_reason}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontFamily: 'Georgia,serif', fontSize: 20, color: '#c94a1e' }}>${d.amount_usd}</div>
                    <div style={{ fontSize: 11, color: '#7a7060', marginTop: 2 }}>
                      {d.disputed_at ? new Date(d.disputed_at).toLocaleDateString('es-ES') : '—'}
                    </div>
                  </div>
                </div>
                {d.ai_score && (
                  <div style={{ marginTop: 8, fontSize: 12, color: '#b45309' }}>
                    AI Score: {d.ai_score}% · {d.ai_verdict}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Detail panel */}
          {selected && (
            <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, padding: 22, height: 'fit-content', position: 'sticky', top: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 17 }}>Resolver disputa</div>
                <button onClick={() => setSelected(null)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#7a7060' }}>✕</button>
              </div>

              {/* Images */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>Foto entrega</div>
                  {selected.delivery_photo_url ? (
                    <img src={selected.delivery_photo_url} alt="Entrega" onClick={() => setImgModal(selected.delivery_photo_url)}
                      style={{ width: '100%', height: 100, objectFit: 'cover', borderRadius: 8, cursor: 'zoom-in', border: '1px solid #e2dbd0' }} />
                  ) : (
                    <div style={{ width: '100%', height: 100, borderRadius: 8, border: '2px dashed #e2dbd0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#b0a090' }}>Sin foto</div>
                  )}
                </div>
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 4 }}>Evidencia disputa</div>
                  {selected.dispute_evidence_url ? (
                    <img src={selected.dispute_evidence_url} alt="Evidencia" onClick={() => setImgModal(selected.dispute_evidence_url)}
                      style={{ width: '100%', height: 100, objectFit: 'cover', borderRadius: 8, cursor: 'zoom-in', border: '1px solid #e2dbd0' }} />
                  ) : (
                    <div style={{ width: '100%', height: 100, borderRadius: 8, border: '2px dashed #e2dbd0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#b0a090' }}>Sin evidencia</div>
                  )}
                </div>
              </div>

              {/* Info */}
              {[
                ['Orden', selected.transaction_ref],
                ['Monto', `$${selected.amount_usd}`],
                ['Entrega a', selected.recipient_name],
                ['Motivo', selected.dispute_reason],
                ['AI Score', selected.ai_score ? `${selected.ai_score}%` : '—'],
                ['AI Flags', selected.ai_flags || '—'],
              ].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #f0ebe2', fontSize: 13 }}>
                  <span style={{ color: '#7a7060' }}>{k}</span>
                  <span style={{ fontWeight: 600, maxWidth: 200, textAlign: 'right', fontSize: 12 }}>{v}</span>
                </div>
              ))}

              {/* Decision */}
              <div style={{ marginTop: 16 }}>
                <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 10 }}>Decisión</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                  <button onClick={() => setDecision('release')} style={{ padding: '12px', borderRadius: 8, border: `2px solid ${decision === 'release' ? '#2d6a4f' : '#e2dbd0'}`, background: decision === 'release' ? '#eaf4ef' : '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 700, color: decision === 'release' ? '#2d6a4f' : '#7a7060' }}>
                    ✓ Liberar al agente
                  </button>
                  <button onClick={() => setDecision('refund')} style={{ padding: '12px', borderRadius: 8, border: `2px solid ${decision === 'refund' ? '#9b2c5e' : '#e2dbd0'}`, background: decision === 'refund' ? '#faeef4' : '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 700, color: decision === 'refund' ? '#9b2c5e' : '#7a7060' }}>
                    ↩ Reembolsar sender
                  </button>
                </div>

                <textarea
                  value={notes}
                  onChange={e => setNotes(e.target.value)}
                  placeholder="Notas de la resolución (requerido)..."
                  style={{ width: '100%', padding: '10px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', resize: 'vertical', minHeight: 70, marginBottom: 10 }}
                />

                <button onClick={handleResolve} disabled={resolving || !decision || !notes.trim()} style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: (resolving || !decision || !notes.trim()) ? '#e2dbd0' : '#c94a1e', color: '#fff', fontSize: 14, fontWeight: 700, cursor: (resolving || !decision || !notes.trim()) ? 'not-allowed' : 'pointer' }}>
                  {resolving ? 'Procesando...' : 'Confirmar resolución'}
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Reserve fund tab */}
      {tab === 'fund' && fund && (
        <div>
          {/* Summary cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 24 }}>
            {[
              { label: 'Balance actual', value: `$${(fund.summary?.current_balance || 0).toFixed(2)}`, color: '#2d6a4f', bg: '#eaf4ef' },
              { label: 'Total recaudado', value: `$${(fund.summary?.total_collected || 0).toFixed(2)}`, color: '#c94a1e', bg: '#fdf4f0' },
              { label: 'Total reembolsado', value: `$${(fund.summary?.total_refunded || 0).toFixed(2)}`, color: '#9b2c5e', bg: '#faeef4' },
            ].map(s => (
              <div key={s.label} style={{ background: s.bg, borderRadius: 14, padding: '18px 20px' }}>
                <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: s.color, marginBottom: 4 }}>{s.value}</div>
                <div style={{ fontSize: 12, color: s.color, fontWeight: 600 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* History */}
          <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid #e2dbd0', fontFamily: 'Georgia,serif', fontSize: 15 }}>
              Historial de movimientos
            </div>
            {fund.history?.length === 0 ? (
              <div style={{ padding: 32, textAlign: 'center', color: '#7a7060', fontSize: 13 }}>Sin movimientos todavía</div>
            ) : fund.history?.map((h, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', borderBottom: '1px solid #f0ebe2' }}>
                <div>
                  <div style={{ fontFamily: 'monospace', fontSize: 11, color: '#c94a1e', marginBottom: 2 }}>{h.transaction_ref}</div>
                  <div style={{ fontSize: 13, color: '#7a7060' }}>
                    {h.type === 'RESERVE' ? '+ Reserva' : '- Reembolso'}
                    {h.notes && ` · ${h.notes}`}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 700, fontSize: 15, color: h.amount_usd > 0 ? '#2d6a4f' : '#9b2c5e' }}>
                    {h.amount_usd > 0 ? '+' : ''}${Math.abs(h.amount_usd).toFixed(2)}
                  </div>
                  <div style={{ fontSize: 11, color: '#b0a090' }}>
                    {h.created_at ? new Date(h.created_at).toLocaleDateString('es-ES') : '—'}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
